import React, { useEffect, useState } from 'react';
import { Link, withRouter } from "react-router-dom";
import Slider from '../../Services/Slider';
import Alert from '../../Services/Alert';

/* Same order as the app shows them: sort_order ascending, ties newest first.
   (The API already sorts; this keeps the page right even against an older API.) */
const byDisplayOrder = (a, b) =>
  ((a.sort_order || 0) - (b.sort_order || 0)) || (new Date(b.createdAt) - new Date(a.createdAt));

export const SliderList = (props) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  function loadBanners() {
    setLoading(true);
    Slider.list({ page: 0, size: 100, search: "", type: "mobile" }).then((res) => res.data).then(res => {
      if (res.status) {
        setBanners([...(res.data.docs || [])].sort(byDisplayOrder));
      } else {
        Alert.error(res.message);
      }
    }).catch(error => {
      Alert.error(error.message);
    }).finally(() => setLoading(false));
  }

  useEffect(() => {
    loadBanners();
  }, []);

  /* Banners are never deleted: they are deactivated (hidden from the app) and can be activated again. */
  function setActive(banner, active) {
    const message = active
      ? `"${banner.title}" will be shown in the app.`
      : `"${banner.title}" will be hidden from the app. You can activate it again later.`;
    Alert.warning(message).then((result) => {
      if (!result.isConfirmed) return;
      Slider.update_status({ id: banner._id, status: active ? 1 : '0' }).then((res) => res.data).then(res => {
        if (res.status) {
          Alert.success(active ? 'Banner activated.' : 'Banner deactivated.');
          loadBanners();
        } else {
          Alert.error(res.message);
        }
      }).catch(error => {
        Alert.error(error.message);
      });
    });
  }

  const activeCount = banners.filter((b) => b.status).length;

  return (
    <>
      <section className="main-content slider_main_sec">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="header-text">
                      <h4 className="card-title mb-4">Banners</h4>
                      <div className="edit-btn">
                        <Link to="/slider/add" className="btn btn-outline-primary mr-4 btn-sm btn-rounded waves-effect waves-light">
                          <i className='bx bx-add-to-queue'></i>
                          Add Banner
                        </Link>
                      </div>
                    </div>
                    <p className="text-muted mb-3">
                      The app's home screen shows the <b>active</b> banners in this order ({activeCount} active now).
                      Banners can't be deleted: deactivate a banner to hide it.
                    </p>
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="align-middle">Order</th>
                            <th className="align-middle">Banner</th>
                            <th className="align-middle">Title</th>
                            <th className="align-middle">Status</th>
                            <th className="align-middle">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading && banners.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center text-muted">No banners yet. Use "Add Banner" to create one.</td>
                            </tr>
                          )}
                          {banners.map((banner) => (
                            <tr key={banner._id}>
                              <td>{banner.sort_order || 0}</td>
                              <td>
                                {/* 16:6 and stretched, exactly like the app draws it */}
                                <img src={banner.image_url} alt={banner.title}
                                  style={{ width: 160, height: 60, objectFit: 'fill', borderRadius: 6, opacity: banner.status ? 1 : 0.45 }} />
                              </td>
                              <td>{banner.title}</td>
                              <td>
                                {banner.status
                                  ? <span className="badge bg-success">Active</span>
                                  : <span className="badge bg-secondary">Inactive</span>}
                              </td>
                              <td>
                                <Link to={{ pathname: `/slider/edit/${banner._id}` }} className="btn btn-outline-secondary btn-sm btn-rounded waves-effect waves-light">
                                  <i className='bx bxs-edit'></i>
                                  Edit
                                </Link>&nbsp;&nbsp;
                                {banner.status ? (
                                  <button type="button" onClick={() => setActive(banner, false)} className="btn btn-outline-danger btn-sm btn-rounded waves-effect waves-light">
                                    <i className='bx bx-hide'></i>
                                    Deactivate
                                  </button>
                                ) : (
                                  <button type="button" onClick={() => setActive(banner, true)} className="btn btn-outline-success btn-sm btn-rounded waves-effect waves-light">
                                    <i className='bx bx-show'></i>
                                    Activate
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default withRouter(SliderList);
